// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from '../../i18n/I18n';


import classNames from 'classnames';

class FixedSubmitArea extends Component {

  static defaultProps = {
    shouldDisableSubmit: false
  };

  static propTypes = {
    haveModifications: PropTypes.bool.isRequired,

    onSubmit: PropTypes.func.isRequired,

    onReset: PropTypes.func.isRequired,

    shouldDisableSubmit: PropTypes.bool
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.haveModifications !== this.props.haveModifications
     || nextProps.shouldDisableSubmit !== this.props.shouldDisableSubmit;
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(event);
  };

  onReset = (event) => {
    event.preventDefault();
    this.props.onReset(event);
  };

  get shouldDisableSubmit(): boolean {
    return this.props.shouldDisableSubmit
  }

  get haveModifications(): boolean {
    return this.props.haveModifications;
  }

  render() {
    const className = classNames('fixed_submit_area', {
      hidden: !this.haveModifications
    });

    let saveButton = (
      <button
        className="btn btn-primary"
        onClick={(event) => { event.preventDefault(); this.onSubmit(event); }}
        type="submit"
      >
        {I18n.tr('components.fixed_submit_area.save')}
      </button>
    );

    if (!this.haveModifications || this.shouldDisableSubmit) {
      saveButton = (
        <button className="btn btn-primary" disabled>
          {I18n.tr('components.fixed_submit_area.save')}
        </button>
      );
    }

    return (
      <div className={className} key={this.haveModifications}>

        <button
          className="btn"
          onClick={(event) => { event.preventDefault(); this.onReset(event); }}
          type="reset"
        >
          {I18n.tr('components.fixed_submit_area.cancel')}
        </button>

        &nbsp;&nbsp;&nbsp;&nbsp;

        {saveButton}
      </div>
    );
  }

}

export default FixedSubmitArea;
